export default __webpack_public_path__ + "static/media/attendance management system.fc0a804c.md";